import { render } from "./InterestNotes.vue?vue&type=template&id=1ca6a562&scoped=true"
import script from "./InterestNotes.vue?vue&type=script&lang=js"
export * from "./InterestNotes.vue?vue&type=script&lang=js"

import "./InterestNotes.vue?vue&type=style&index=0&id=1ca6a562&lang=scss&scoped=true"

import exportComponent from "/Users/patrykslak/Documents/projekty/lauron-system/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ca6a562"]])

export default __exports__